import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import type { History } from 'history';
import { responsiveStoreEnhancer } from 'redux-responsive';
import { fromJS } from 'immutable';
import { routerMiddleware } from 'connected-react-router/immutable';

import { getViewInitialState } from 'src/store/view/reducer';
import { isWebGlSupported } from 'src/utils/mapUtils';
import { makeMockTourists } from 'src/utils/mockUtils';
import { DEFAULT_TOPBAR_SLIDE } from 'src/constants';

import { transformRoomInfo } from 'src/helpers/transforms/roomInfo';
import { ORDER_COMMENT_CHECKBOXES } from 'checkout/store/constants/order';
import { visaDTO } from 'src/routes/Checkout/store/domains/visa/visaDTO';
import sagas from './sagas';
import createRootReducer from './reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];

const getStore = (props, history = '' as unknown as History<unknown>) => {
  const {
    hotel,
    package: packageData,
    order: orderData,
    visa,
    isMobile,
    data,
    logo,
    roomInfo,
    user,
    platform,
    availableSearchTypes,
    partner_id,
  } = props;

  const preloadedState = {
    view: {
      isMobile,
      topbarIndex: DEFAULT_TOPBAR_SLIDE,
      isTopbarExpanded: false,
      isRoomPopupOpened: false,
      isWebGlSupported: isWebGlSupported(),
      platform,
      showFilters: false,
      isWidgetShown: true,
      searchType: packageData.search_type,
      availableSearchTypes: availableSearchTypes || undefined,
      activeTouristForm: 0,
      ...getViewInitialState(),
    },
    hotel,
    data: {
      ...data,
      mockTourists: makeMockTourists(packageData),
    },
    roomInfo: roomInfo ? transformRoomInfo(roomInfo) : {},
    visa: visaDTO(visa),
    package: {
      ...packageData,
      partner_id,
    },
    testimonials: {
      data: [],
      fetching: false,
    },
    order: {
      isClientConfirmed: false,
      isTouristsConfirmed: false,
      priceInfo: [],
      isCreating: false,
      isCreated: false,
      isProcessing: false,
      isProcessed: false,
      isFinished: false,
      isPrebuildFetching: false,
      isPrebuilt: false,
      showOrderErrorPopup: false,
      comment: {
        text: '',
        checkboxes: ORDER_COMMENT_CHECKBOXES,
      },
      jointOrder: {
        ordersAmount: 0,
        firstOrderNumber: 0,
        isFirstOrder: null,
      },
      bonuses: orderData.bonuses,
    },
    logo,
    services: [],
    error: {
      isOpened: false,
    },
    user: user || {},
  };
  const store = createStore(
    createRootReducer(history),
    fromJS(preloadedState),
    composeEnhancers(
      responsiveStoreEnhancer,
      applyMiddleware(...middlewares, routerMiddleware(history)),
    ),
  );
  sagaMiddleware.run(sagas);
  return store;
};

export default getStore;
